import React, { useEffect, useState, useRef } from 'react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import {
  createManufacturer,
  updateManufacturer,
  deleteManufacturer,
  getManufacturer,
  checkManufacturerExists,
} from '../api/manufacturerAPI';
import $ from 'jquery';
import { Icon } from '@iconify/react';

const ManufacturerListLayer = () => {
  const userProfile = useUserProfile();
  const [manufacturerList, setManufacturerList] = useState([]);
  const [newManufacturer, setNewManufacturer] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const fetchData = async () => {
    const data = await getManufacturer();
    setManufacturerList(data);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newManufacturer.manufacturer?.trim()) newErrors.manufacturer = 'Manufacturer is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (manufacturerList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({ pageLength: 25, dom: 'rtip' });
    }
    return () => dtRef.current?.destroy(true);
  }, [manufacturerList]);

  useEffect(() => {
    dtRef.current?.search(searchTerm).draw();
  }, [searchTerm]);

  const handleSave = async () => {
    if (!validateForm()) return;
    const clean = {};
    for (const key in newManufacturer) {
      if (newManufacturer[key] !== null && typeof newManufacturer[key] !== 'object') {
        clean[key] = newManufacturer[key];
      }
    }
    const exists = await checkManufacturerExists(clean.manufacturer, editingId);
    if (exists) {
      setErrors({ manufacturer: 'Manufacturer already exists' });
      return;
    }
    editingId
      ? await updateManufacturer(editingId, clean)
      : await createManufacturer(clean);
    setShowModal(false);
    setEditingId(null);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    setNewManufacturer({});
    await fetchData();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete manufacturer?')) return;
    await deleteManufacturer(id);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    await fetchData();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewManufacturer(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between p-3">
        <input type="text" className="form-control w-auto" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        {userProfile?.privileges?.includes('manufacturers:create') && (
          <button className="btn btn-primary btn-sm d-flex align-items-center gap-2" onClick={() => { setNewManufacturer({}); setEditingId(null); setShowModal(true); }}>
            <Icon icon="ic:baseline-plus" className="icon text-xl" /> Add Manufacturer
          </button>
        )}
      </div>

      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table ref={tableRef} className="table bordered-table mb-0">
            <thead><tr><th>Name</th><th>Website</th><th>Actions</th></tr></thead>
            <tbody>
              {manufacturerList.map(item => (
                <tr key={item.id}>
                  <td><strong>{item.manufacturer}</strong></td>
                  <td><a href={item.website} target="_blank" rel="noreferrer">{item.website}</a></td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('manufacturers:update') && (
                        <button className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => { setNewManufacturer(item); setEditingId(item.id); setShowModal(true); }}>
                          <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('manufacturers:delete') && (
                        <button className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleDelete(item.id)}>
                          <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg"><div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">{editingId ? 'Edit Manufacturer' : 'New Manufacturer'}</h5><button className="btn-close" onClick={() => setShowModal(false)} /></div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Manufacturer *</label>
                <input className={`form-control ${errors.manufacturer ? 'is-invalid' : ''}`} name="manufacturer" value={newManufacturer.manufacturer || ''} onChange={handleInputChange} />
                {errors.manufacturer && <div className="invalid-feedback">{errors.manufacturer}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Website</label>
                <input className="form-control" name="website" value={newManufacturer.website || ''} onChange={handleInputChange} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </div>
          </div></div>
        </div>
      )}
    </div>
  );
};

export default ManufacturerListLayer;
